import { render, staticRenderFns } from "./TosCustomer.vue?vue&type=template&id=77503c88&scoped=true&"
import script from "./TosCustomer.vue?vue&type=script&lang=js&"
export * from "./TosCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TosCustomer.vue?vue&type=style&index=0&id=77503c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77503c88",
  null
  
)

export default component.exports